import './index.less';

const { Feature, meta, hook, event } = checkApp.core; //eslint-disable-line
const { Button, Tooltip, Loading } = checkApp.components;//eslint-disable-line

const adData = window._bottomAd || {
  image: '//img.alicdn.com/tfs/TB1oPsfkwDD8KJjy0FdXXcjvXXa-924-126.png',
  link: '//promotion.aliyun.com/ntms/act/jianzhandiscount2017.html'
};

@meta('bottomAd', [], 100)
export default class BottomADFeature extends Feature {

  /**
   * 渲染右侧面板
   * @param {object} state 状态对象
   * @returns {objecg} 面板 dom
   */
  @hook('main.renderMainPanel')
  renderSidePanel() {
    return <a key={this.id}
      className="panel side ad-panel"
      target="_blank"
      href={adData.link || adData.value}>
      <img alt="ad" src={adData.image || adData.text} />
    </a>;
  }

}


// WEBPACK FOOTER //
// ./src/bottom-ad/index.js